import styled from 'styled-components';

const CasinoBonus = styled.div`
  border-radius: 8px;
  background: linear-gradient(91deg, #6d3d00 0.57%, #191919 99.43%);
  position: relative;
  height: 120px;

  ${({ $bgMod }) =>
    $bgMod &&
    `
background-image: url(/images/icons/welcom_banner_signUp/pingwin-wellcom-mob.png);
 background-repeat: no-repeat;
 aspect-ratio: 380 / 143;
    background-size: cover;

`}
  &:before {
    content: '';

    position: absolute;
    top: 9px;
    left: 0;

    width: 77px;
    height: 104px;
    flex-shrink: 0;
    aspect-ratio: 77/104;

    background-image: url(/images/icons/welcom_banner_signUp/money_banner.svg);
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media (max-width: 768px) {
    margin: 0 -18px;
    border-radius: 0;

    &:before {
      display: none;
    }
  }
`;

const ChangeBonus = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: end;
  padding: 10px;

  @media (max-width: 768px) {
    height: auto;
    padding: 8px;
  }
`;
const ContentBonus = styled.div`
  display: flex;
  align-items: start;
  width: max-content;
  margin-left: 89px;
  max-width: 170px;
  gap: 3px;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  @media (max-width: 768px) {
    gap: 14px;
    margin: 0;
    padding: 14px 18px;
    max-width: max-content;
  }
`;

const InfoContainer = styled.div`
  border-radius: 8px;
  backdrop-filter: blur(18px);

  display: flex;
  padding: 12px 18px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;

  align-self: stretch;
  position: relative;
  background: rgba(19, 19, 21, 0.75);

  @media (max-width: 768px) {
    backdrop-filter: none;
    background: none;
    flex: 1 0 0;
    justify-content: flex-start;
    padding: 0;
  }
`;

const ListInfo = styled.div`
display: flex;
align-items: center;
flex-direction: column;
    width: 100%;
    margin-top: 60px;
    gap: 3px;
}


`;
const ListClose = styled.div`
  top: 10px;
  cursor: pointer;
  position: absolute;
  right: 10px;
`;

const InfoIcon = styled.div`
  cursor: pointer;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;

  @media (max-width: 768px) {
    margin-top: 0;
    border-radius: 8px 8px 0 0;
    background: #27262b;
    padding: 12px;
    border-radius: ${(props) => props.$topRadius && '8px 8px 0 0'};
    border-radius: ${(props) => props.$bottomRadius && '0 0 8px 8px'};
    border-radius: ${(props) =>
      !props.$topRadius && !props.$bottomRadius && '0'};
  }
`;

const BoxItems = styled.div`
  width: 100%;
  margin-top: 30px;

  display: flex;
  flex-direction: column;
  gap: 3px;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const MobileLandscapeWrapper = styled.div`
  height: 100%;
`;

export const MobileLandscapeContent = styled.div`
  // background: #2C2C2C;
  border-radius: 12px;
  // padding: 20px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
`;

export {
  CasinoBonus,
  ChangeBonus,
  ContentBonus,
  InfoContainer,
  ListInfo,
  InfoItem,
  ListClose,
  BoxItems,
  InfoIcon,
};
